import * as React from "react";
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { CSVLink } from "react-csv";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { MyDocument } from "./MyDocument";

const data = [
  {
    id: 1,
    ticketId: "TKT001",
    subject: "This is a sample subject",
    description: "This is a sample description",
    firstName: "John",
    lastName: "Doe",
    email: "johndoe@example.com",
    date: "2022-01-01",
    timeIn: "10:00 AM",
    timeOut: "12:00 PM",
    admin:'Tola',
    oldestCall: "11:00 AM",
  },
  {
    id: 2,
    ticketId: "TKT002",
    subject: "This is another sample subject",
    description: "This is another sample description",
    firstName: "Jane",
    lastName: "Doe",
    email: "janedoe@example.com",
    date: "2022-01-02",
    timeIn: "9:00 AM",
    timeOut: "11:00 AM",
    admin:'Bruce',
    oldestCall: "10:00 AM",
  },
  // add more data as needed
];

const columns = [
  "Ticket ID",
  "Subject",
  "Description",
  "First Name",
  "Last Name",
  "Email",
  "Date",
  "Time In",
  "Time Out",
  "Admin",
  "Oldest Call",
];

const ExportButtons = ({ data }) => (
  <div style={{display:'flex', gap:'3rem'}}>
    <CSVLink data={data}>Export CSV</CSVLink>
    {'    '}
    <PDFDownloadLink
      document={<MyDocument data={data} />}
      fileName="tickets.pdf"
    >
      {({ blob, url, loading, error }) =>
        loading ? "Loading..." : "Print PDF"
      }
    </PDFDownloadLink>
  </div>
);

const filterByDateRange = (data, startDate, endDate) => {
  if (!startDate || !endDate) return data;

  const start = new Date(startDate);
  const end = new Date(endDate);

  return data.filter((row) => {
    const date = new Date(row.date);
    return date >= start && date <= end;
  });
};

const ReportTable = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOption, setFilterOption] = useState("Ticket ID");

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
const handleFilterOptionChange = (event) => {
    setFilterOption(event.target.value);
    setSearchTerm("");
  };

  const filteredData =
    filterOption === "Ticket ID"
      ? data.filter((row) =>
          row.ticketId.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : filterOption === "Subject"
      ? data.filter((row) =>
          row.subject.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : filterOption === "Admin"
      ? data.filter((row) =>
          row.admin.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : data;

  const pageData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return(
<>
<Box sx={{ p: 2 }}>
<TextField
label="Start Date"
type="date"
focused
sx={{ mr: 2 }}
/>
<TextField
label="End Date"
type="date"
focused
/>
  <TextField
          id="search"
          label="Search"
          type="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <TextField
          id="filter"
          select
          label="Filter"
          value={filterOption}
          onChange={handleFilterOptionChange}
        >
          <MenuItem value="Ticket ID">Ticket ID</MenuItem>
          <MenuItem value="Subject">Subject</MenuItem>
          <MenuItem value="Admin">Admin</MenuItem>
        </TextField>
</Box>
<Box sx={{ p: 2 }}>
<ExportButtons data={filteredData} />
</Box>
<TableContainer component={Paper}>
<Table>
<TableHead>
<TableRow>
{columns.map((column) => (
<TableCell key={column}>{column}</TableCell>
))}
</TableRow>
</TableHead>
<TableBody>
{pageData.map((row) => (
<TableRow key={row.ticketId}>
<TableCell>{row.ticketId}</TableCell>
<TableCell>{row.subject}</TableCell>
<TableCell>{row.description}</TableCell>
<TableCell>{row.firstName}</TableCell>
<TableCell>{row.lastName}</TableCell>
<TableCell>{row.email}</TableCell>
<TableCell>{row.date}</TableCell>
<TableCell>{row.timeIn}</TableCell>
<TableCell>{row.timeOut}</TableCell>
<TableCell>{row.admin}</TableCell>
<TableCell>{row.oldestCall}</TableCell>
</TableRow>
))}
</TableBody>
<TableFooter>
<TableRow>
<TablePagination
rowsPerPageOptions={[5, 10, 25]}
count={filteredData.length}
rowsPerPage={rowsPerPage}
page={page}
onPageChange={handleChangePage}
onRowsPerPageChange={handleChangeRowsPerPage}
/>
</TableRow>
</TableFooter>
</Table>
</TableContainer>

</>
);
}

export default ReportTable;
